import { useMutation } from '@tanstack/react-query'

import { type IEditLoad } from '../../types'
import { useUpFetch } from '../../utils'

export const useEditLoad = ({ loadId }: { loadId: number }) => {
  const upFetch = useUpFetch()

  return useMutation({
    mutationFn: async (data: IEditLoad) =>
      upFetch(`/loads/${loadId}`, {
        body: data,
        method: 'PATCH',
      }),
  })
}

export const usePatchDropAddress = ({ loadId }: { loadId: number }) => {
  const upFetch = useUpFetch()

  return useMutation({
    mutationFn: async ({ addressId, dropId }: { addressId: number; dropId: number }) =>
      upFetch(`/loads/${loadId}/drops/${dropId}/address`, {
        body: {
          address_id: addressId,
        },
        method: 'PATCH',
      }),
  })
}
